// front-end/src/components/block-system/block-configs/block-types/accordion-item.js

export function createAccordionItem(block, parent) {
    const blockName = block.data_block_name;
    const parentId = parent.id || parent.getAttribute('class');

    // Проверяем, что это именно work-process-accordion
    if (parentId !== 'work-process-accordion') {
        console.warn('Accordion item can only be created for work-process-accordion');
        return null;
    }

    // Извлекаем номер блока
    const blockNumber = getBlockNumber(blockName);

    // Use DOM position for reliable sequential numbering
    const displayNumber = parent.querySelectorAll('.accordion-case-item').length + 1;

    // Создаем основной контейнер аккордеона
    const row = document.createElement('div');
    row.className = 'accordion-case-item';
    row.setAttribute('data-block-name', blockName);

    if (block.id && block.id !== 'undefined') {
        row.setAttribute('data-block-id', block.id);
    }

    if (block.order !== undefined && block.order !== null) {
        row.setAttribute('data-order', String(block.order));
    } else {
        row.setAttribute('data-order', '0');
    }

    row.style.position = 'relative';

    // Определяем теги для контента
    const blockPrefix = 'work-process-step';
    const titleTag = `${blockPrefix}-title-${blockNumber}`;
    const imageTag = `${blockPrefix}-image-${blockNumber}`;
    const descriptionTag = `${blockPrefix}-description-${blockNumber}`;
    const dataPage = 'about-work';

    // Создаем HTML по образцу из home-cases-loader
    //language=HTML
    const accordionHTML = `
        <div class="accordion-header work-process-header">
            <div class="row align-items-center">
                <div class="col-md-6 d-none d-md-flex align-items-center justify-content-between">
                    <div class="work-process-number"><span>${displayNumber}</span></div>
                    <div class="work-process-header-image">
                        <img class="work-process-step-image-small" src="" alt="" data-content="${imageTag}"
                             data-type="image"
                             data-page="${dataPage}">
                    </div>
                </div>

                <div class="col-12 col-md-6 d-flex align-items-center justify-content-between">
                    <div class="work-process-number d-md-none"><span>${displayNumber}</span></div>

                    <h4 class="header-text-accordion" data-content="${titleTag}" data-page="${dataPage}"></h4>
                    <div class="accordion-toggle" aria-label="Розгорнути">
                        <img src="/images/accordion-closed.svg" alt="">
                    </div>
                </div>
            </div>
        </div>

        <div class="accordion-content collapsed">
            <div class="accordion-content-inner work-process-inner">
                <div class="row">
                    <div class="col-12 col-md-6 work-process-image-half d-md-flex justify-content-between">
                        <div class="row d-md-none">
                            <div class="col-6 d-flex justify-content-between align-items-center">
                                <div class="work-process-number"><span>${displayNumber}</span></div>
                                <h4 class="work-process-mobile-header" data-content="${titleTag}"
                                    data-page="${dataPage}"></h4>
                            </div>
                            <div class="col-6 d-flex justify-content-end">
                                <div class="close-accordion aria-label=" Згорнути
                                " type="button">
                                <img src="/images/opened-accordion.svg" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="work-process-number d-none d-md-block"><span>${displayNumber}</span></div>
                    <div class="d-none d-md-block work-process-image-container">
                        <img class="work-process-step-image" src="" alt="" data-content="${imageTag}"
                             data-type="image"
                             data-page="${dataPage}">
                    </div>

                </div>

                <div class="col-12 col-md-6 work-process-description-half d-md-flex justify-content-between">
                    <div class="work-process-content">
                        <h4 class="d-none d-md-inline-block" data-content="${titleTag}" data-page="${dataPage}"></h4>
                        <div class="work-process-description">
                            <p data-content="${descriptionTag}" data-type="textarea" data-page="${dataPage}"></p>
                        </div>
                    </div>
                    <div class="close-accordion d-none d-md-block" aria-label="Згорнути" type="button">
                        <img src="/images/opened-accordion.svg" alt="">
                    </div>
                </div>
                <div class="d-block d-md-none work-process-image-container-mobile">
                    <img class="work-process-step-image" src="" alt="" data-content="${imageTag}"
                         data-type="image"
                         data-page="${dataPage}">
                </div>
            </div>
        </div>
        </div>
    `;

    // Устанавливаем HTML
    row.innerHTML = accordionHTML;

    // Добавляем функциональность accordion
    setupWorkProcessAccordionFunctionality(row);

    parent.appendChild(row);
    return row;
}

function setupWorkProcessAccordionFunctionality(accordionItem) {
    const toggleButton = accordionItem.querySelector('.accordion-toggle');
    const header = accordionItem.querySelector('.accordion-header');
    const content = accordionItem.querySelector('.accordion-content');
    const closeButtons = accordionItem.querySelectorAll('.close-accordion');

    const toggleAccordion = (e) => {
        e.stopPropagation();

        const isCollapsed = content.classList.contains('collapsed');

        // Если раскрываем текущий элемент, закрываем все остальные
        if (isCollapsed) {
            const sectionElement = findParentSection(accordionItem);
            if (sectionElement) {
                const expandedItems = sectionElement.querySelectorAll('.accordion-case-expanded');
                expandedItems.forEach(item => {
                    if (item !== accordionItem) {
                        collapseAccordionItem(item);
                    }
                });
            }
        }

        // Переключаем классы для текущего элемента
        content.classList.toggle('collapsed', !isCollapsed);
        content.classList.toggle('expanded', isCollapsed);
        accordionItem.classList.toggle('accordion-case-expanded', isCollapsed);

        // Обновляем доступность
        toggleButton.setAttribute('aria-label', isCollapsed ? 'Згорнути' : 'Розгорнути');

        if (isCollapsed) {
            content.style.maxHeight = content.scrollHeight + 'px';
            header.style.display = 'none';
        } else {
            content.style.maxHeight = '0';
            header.style.display = 'block';
        }
    };

    // Обработчики событий
    toggleButton.addEventListener('click', toggleAccordion);
    header.addEventListener('click', function(e) {
        if (e.target !== toggleButton && !toggleButton.contains(e.target)) {
            toggleAccordion(e);
        }
    });

    // Добавляем обработчик для всех кнопок закрытия
    closeButtons.forEach(closeButton => {
        closeButton.addEventListener('click', toggleAccordion);
    });

    content.style.overflow = 'hidden';
    content.style.transition = 'max-height 0.4s ease';
    content.style.maxHeight = '0';
}

// Функция для закрытия элемента аккордеона
function collapseAccordionItem(accordionItem) {
    const itemHeader = accordionItem.querySelector('.accordion-header');
    const itemContent = accordionItem.querySelector('.accordion-content');
    const itemToggleButton = accordionItem.querySelector('.accordion-toggle');

    // Сворачиваем контент
    itemContent.classList.remove('expanded');
    itemContent.classList.add('collapsed');
    accordionItem.classList.remove('accordion-case-expanded');

    // Обновляем доступность
    if (itemToggleButton) {
        itemToggleButton.setAttribute('aria-label', 'Розгорнути');
    }

    // Анимируем высоту
    itemContent.style.maxHeight = '0';

    // Показываем заголовок
    if (itemHeader) {
        itemHeader.style.display = 'block';
    }
}

// Вспомогательная функция для поиска родительской секции
function findParentSection(element) {
    let parent = element.parentElement;
    while (parent) {
        if (parent.hasAttribute('data-section')) {
            return parent;
        }
        parent = parent.parentElement;
    }
    return null;
}

// Функция для извлечения номера из имени блока
function getBlockNumber(blockName) {
    const match = blockName.match(/-(\d+)$/);
    return match ? match[1] : '1';
}

export const accordionItemProps = {
    name: 'work-process-step',
    title: 'Етап робочого процесу',
    description: 'Елемент аккордеону для опису етапів робочого процесу',
    allowedParents: ['work-process-accordion'],
    contentFields: [
        {name: 'title', type: 'text', label: 'Заголовок етапу'},
        {name: 'description', type: 'textarea', label: 'Опис етапу'},
        {name: 'image', type: 'image', label: 'Зображення етапу'}
    ],
    renderPreview: (data) => {
        return `
      <div class="block-preview work-process-preview">
        <div class="row">
          <div class="col-lg-6">
            <div class="image-placeholder"></div>
          </div>
          <div class="col-lg-6">
            <h4>${data.title}</h4>
            <p>${data.description}</p>
          </div>
        </div>
      </div>
    `;
    }
};